<template>
  <div class="div-dropdown-component">
    <SingleSelectInteger
      :value.sync="compValue"
      :value-property="'value'"
      :options="optionsVehicleModels"
      :readonly="readonly"
    />
    <span v-if="problemToList" class="text-danger">
      {{ errorMessage }}
    </span>
  </div>
</template>

<script>
export default {
  name: "VehicleModelDropdown",
  props: {
    vehicleModelId: Number,
    vehicleModels: Array,
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    "SingleSelectInteger": () => import("@/components_rms/base/SingleSelectInteger.vue"),
  },
  data() {
    return {
      errorMessage: null,
      optionsVehicleModels: [
        { value: null, text: "Carregando modelos de veículos" },
      ],
    };
  },
  created() {
    if (this.vehicleModels && this.vehicleModels != null) {
      this.optionsVehicleModels = this.vehicleModels;
    } else {
      this.loadVehicleModels();
    }
  },
  computed: {
    compValue: {
      get: function () {
        return this.vehicleModelId;
      },
      set: function (newValue) {
        this.$emit("update:vehicleModelId", newValue);
      },
    },
    problemToList() {
      return this.errorMessage && this.errorMessage != "";
    },
  },
  methods: {
    loadVehicleModels() {
      this.$apiScheduler
        .get("/vehicleModel/list")
        .then((response) => {
          this.optionsVehicleModels = response.data.map((item) => ({
            value: item.id.toString(),
            text: item.name,
          }));
        })
        .catch((error) => {
          this.optionsVehicleModels = [
            { value: null, text: "Erro ao carregar modelos de veículos" },
          ];
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.errorMessage = error.message;
          }
        });
    },
  },
};
</script>